export default {
  1: "پست",
  2: "اکسپرس ماهکس",
  3: "کالارسانان چاپار",
  4: "رابر",
  5: "آواکس",
  6: "تیپاکس",
  7: "آواپیما",
  8: "سامان اکسپرس",
  9: "دکاپست",
};
